import React from 'react';
import PropTypes from 'prop-types';

import {
  getPagePath,
  useSoyuzLocales,
  useSoyuzRequest,
  useSoyuzServer
} from '@spotahome/soyuz/client';

import { SideMenu as SideMenuComponent } from '@spotahome/ui-library';

export { sideMenuSections } from '@spotahome/ui-library';

const SideMenu = ({ user, selectedOption }) => {
  const { path } = useSoyuzRequest();
  const { current } = useSoyuzLocales();
  const { currentRoute } = useSoyuzServer();

  const onChangeLocale = locale => {
    const query = window.location.search;
    const params = path.params;

    window.location = getPagePath(currentRoute, {
      locale,
      params,
      query
    });
  };

  return (
    <SideMenuComponent
      locales={{
        current,
        onChange: onChangeLocale
      }}
      user={user}
      selectedOption={selectedOption}
    />
  );
};

SideMenu.propTypes = {
  user: PropTypes.shape({
    fullname: PropTypes.string
  }).isRequired,
  selectedOption: PropTypes.string.isRequired
};

export default SideMenu;
